{
  "regex": {
    "alphanumericCharacters": "alphanumeric characters",
    "andContain": "and contain only",
    "anyCharacters": "any characters",
    "contain": "contain only",
    "defaultMessage": "must follow the specified format.",
    "digits": "digits",
    "field": "The",
    "followedBy": "followed by",
    "lengthBetween": "between {{min}} and {{max}} characters long",
    "lengthExact": "{{min}} characters long",
    "letters": "letters",
    "lowercaseLetters": "lowercase letters",
    "mustBe": "must be",
    "nonAlphanumericCharacters": "non-alphanumeric characters",
    "optional": "optional",
    "optionallyFollowedBy": "optionally followed by",
    "underscores": "underscores",
    "uppercaseLetters": "uppercase letters"
  }
}
